import React from 'react';
import styled from '@benzinga/themetron';
import { Button, ButtonVariant } from '@benzinga/core-ui';
import { SmartLink } from '@benzinga/analytics';
import { Product } from '@benzinga/content-manager';
import { ProductCallNow } from './ProductCallNow';
import { sanitizeHTML } from '@benzinga/frontend-utils';
// import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
// import { Icon } from '@benzinga/core-ui';

export interface ProductGetStartedProps {
  buttonText?: string;
  product: Product;
  label: string;
  variant?: ButtonVariant;
}

export const ProductGetStarted: React.FC<React.PropsWithChildren<ProductGetStartedProps>> = ({
  buttonText,
  children,
  label,
  product,
  variant = 'cta',
}) => {
  return (
    <ProductGetStartedContainer className="get-started-button-container">
      <SmartLink className="cta-link-button" href={product.link} label={label}>
        <Button variant={variant}>
          <span dangerouslySetInnerHTML={{ __html: sanitizeHTML(buttonText ?? 'Get Started') }} />
        </Button>
      </SmartLink>
      {product.phone && <ProductCallNow label={label} phone={product.phone || ''} />}
      {product.trust && <span className="securely" dangerouslySetInnerHTML={{ __html: sanitizeHTML(product.trust) }} />}
      {children}
    </ProductGetStartedContainer>
  );
};

const ProductGetStartedContainer = styled.div`
  align-items: center;
  text-align: center;
  .securely {
    display: block;
    font-style: italic;
    font-size: 0.75rem;
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colorPalette.gray500};
  }
`;
